// Para birimi formatlayıcı - TRY
export const formatCurrency = (currencyCode, amount) => {
    return `${currencyCode} ${new Intl.NumberFormat('tr-TR').format(amount)}`;
  };